// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:54:32

export default {
  "id": "yoga-master-flex-running",
  "slug": "yoga-master-flex-running",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/d034b69daef84f718b8b54a97a0f4080-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/d034b69daef84f718b8b54a97a0f4080/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Yoga Master - Flex Running",
      "description": "Yoga Master - Flex Running is an addictive 3D running game with different levels that will challenge even the fastest reflex.\n\nMove your character to adjust the pose and dodge the incoming obstacles while picking some money on the way. But beware! Sometimes this stack of cash is a trap.",
      "instructions": "HOW TO PLAY:\n- Tap or swipe to begin a level.\n- Swipe to move the character.\n- Adjust the pose to dodge the furniture.\n- Don't let anything hit you until the end.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "arcade",
        "collect",
        "run"
      ]
    },
    "zh-CN": {
      "title": "瑜伽大师 - 灵活奔跑",
      "description": "瑜伽大师 - 弹跳跑是一款令人上瘾的3D跑步游戏，不同等级的挑战将考验最快的反应速度。\n\n移动你的角色调整姿势，躲避即将到来的障碍，并在途中捡起一些钱。但小心！有时这堆现金是个陷阱。",
      "instructions": "如何游玩：\n- 点击或滑动开始关卡。\n- 滑动移动角色。\n- 调整姿势躲避家具。\n- 不要让任何东西在游戏结束前击中你。",
      "genres": [
        "休闲"
      ],
      "tags": [
        "街机",
        "收集",
        "奔跑"
      ]
    },
    "zh-TW": {
      "title": "瑜伽大師 - 強化奔跑",
      "description": "瑜伽大師 - 溶解跑步是一款上癮的3D跑步遊戲，不同的等級將挑戰最快的手腳反應。\n\n將您的角色移動以調整姿勢，並躲避來臨的障礙物，同時在途中收集一些金錢。但小心！有時這堆現金其實是陷阱。",
      "instructions": "如何遊玩：\n- 轻觸或滑動開始關卡。\n- 滑動移動角色。\n- 調整姿勢來躲避家具。\n- 無論如何不要讓任何東西碰到你，直到遊戲結束。",
      "genres": [
        "隨意"
      ],
      "tags": [
        "電玩中心",
        "收集",
        "奔跑"
      ]
    },
    "zh-HK": {
      "title": "瑜伽大師 - 柔軟奔跑",
      "description": "瑜伽大師 - 灵活跑酷是一款吸引人的3D跑步遊戲，具有不同等級，將挑戰最快的反應速度。\n\n移動角色調整姿勢，避開即將來襲的障礙物，並在途中拾取一些錢幣。但小心！有時這堆現金是陷阱。",
      "instructions": "如何遊玩：\n- 轻觸或掃描開始遊戲級別。\n- 掃描移動角色。\n- 調整姿勢以避開傢俱。\n- 無論如何都不要讓任何東西撞到你，直到遊戲結束。",
      "genres": [
        "隨機"
      ],
      "tags": [
        "電玩",
        "收集",
        "跑酷"
      ]
    },
    "ja": {
      "title": "ヨガマスター - フレックスランニング",
      "description": "ヨガマスター - フレックスランニングは、最も速い反応も挑戦されるような異なるレベルを持つ魅力的な3Dランニングゲームです。\n\nキャラクターを動かしてポーズを調整し、道中に手に入るお金を拾いつつ、到来する障害物を避けましょう。しかし、気をつけてください！時にはこの金の山が罠かもしれません。",
      "instructions": "遊び方:\n- レベルを開始するにはタップまたはスワイプしてください。\n- キャラクターを動かすにはスワイプしてください。\n- ポーズを調整して家具を避けましょう。\n- 終了まで何も当てられてはなりません。",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "アーケード",
        "収集",
        "走る"
      ]
    },
    "ko": {
      "title": "요가 마스터 - 유연 러닝",
      "description": "요가 마스터 - 유연 러닝(Yoga Master - Flex Running)은 빠른 반응력을 시험하는 다양한 레벨을 갖춘 유취약한 3D 러닝 게임입니다.\n\n캐릭터를 이동하여 포즈를 조정하고, 길가의 장애물을 피하면서 돈을 모으세요. 하지만 주의하세요! 어떤 때는 이 돈이 테러입니다.",
      "instructions": "플레이 방법:\n- 레벨을 시작하려면 탭하거나 스와이프하세요.\n- 캐릭터를 이동시키려면 스와이프하세요.\n- 포즈를 조정하여 가구를 피하세요.\n- 마지막까지 아무것도 당하지 마세요.",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "아케이드",
        "모으기",
        "달리기"
      ]
    },
    "fr": {
      "title": "Maître du Yoga - Course Flex",
      "description": "Yoga Master - Flex Running est un jeu de course en 3D accrocheur avec différents niveaux qui challenge même les plus rapides reflexes.\n\nDéplacez votre personnage pour ajuster la posture et éviter les obstacles arrivants tout en ramassant de l'argent sur le chemin. Mais attention ! Parfois, ce tas d'argent est une piège.",
      "instructions": "COMMENT JOUER :\n- Tapez ou faites glisser pour commencer un niveau.\n- Faites glisser pour déplacer le personnage.\n- Ajustez la pose pour éviter le mobilier.\n- Ne laissez rien vous toucher jusqu'à la fin.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "arcade",
        "collecter",
        "courir"
      ]
    }
  }
};
